import React, { useState, useEffect } from "react";
import ReactQuill from "react-quill-new";
import "react-quill-new/dist/quill.snow.css";
import {
  getArticles,
  addArticle,
  updateArticle,
  deleteArticle,
  uploadImage,
} from "./firestoreServices";

const LibraryDashboard = () => {
  const [articles, setArticles] = useState([]);

  // ضيفنا content في الحالة
  const [form, setForm] = useState({
    img: "",
    date: new Date().toISOString().split("T")[0],
    ar: { title: "", category: "", excerpt: "", content: "" },
    en: { title: "", category: "", excerpt: "", content: "" },
  });

  const [file, setFile] = useState(null);
  const [editId, setEditId] = useState(null);

  useEffect(() => {
    load();
  }, []);
  const load = async () => {
    setArticles(await getArticles());
  };

  // إعدادات شريط الأدوات (Toolbar)
  const modules = {
    toolbar: [
      [{ header: [1, 2, false] }],
      ["bold", "italic", "underline", "strike", "blockquote"],
      [{ list: "ordered" }, { list: "bullet" }],
      ["link", "clean"],
    ],
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    let imgUrl = form.img;
    if (file) imgUrl = await uploadImage(file);

    const data = { ...form, img: imgUrl };
    if (editId) await updateArticle(editId, data);
    else await addArticle(data);

    // Reset
    setForm({
      img: "",
      date: "",
      ar: { title: "", category: "", excerpt: "", content: "" },
      en: { title: "", category: "", excerpt: "", content: "" },
    });
    setFile(null);
    setEditId(null);
    load();
    alert("تم الحفظ بنجاح");
  };

  const handleEdit = (item) => {
    setForm(item);
    setEditId(item.id);
    window.scrollTo(0, 0);
  };

  const handleDelete = async (id) => {
    await deleteArticle(id);
    load();
  };

  return (
    <div className="dashboard-container">
      <h2 className="page-title">📚 إدارة المدونة والمقالات</h2>

      <div className="admin-card">
        <h3 className="form-title">
          {editId ? "تعديل مقال" : "إضافة مقال جديد"}
        </h3>
        <form onSubmit={handleSubmit}>
          {/* ... (نفس حقول الصورة والتاريخ السابقة) ... */}
          <div className="form-grid">
            <div className="form-group">
              <label>صورة المقال</label>
              <input
                type="file"
                onChange={(e) => setFile(e.target.files[0])}
                style={{ marginBottom: "10px" }}
              />
              <input
                className="admin-input"
                value={form.img}
                onChange={(e) => setForm({ ...form, img: e.target.value })}
                dir="ltr"
              />
            </div>
            <div className="form-group">
              <label>تاريخ النشر</label>
              <input
                type="date"
                className="admin-input"
                value={form.date}
                onChange={(e) => setForm({ ...form, date: e.target.value })}
              />
            </div>
          </div>

          {/* القسم العربي */}
          <div
            style={{
              marginTop: "20px",
              padding: "20px",
              border: "1px solid #ddd",
              borderRadius: "8px",
              background: "#fcfcfc",
            }}
          >
            <h4 style={{ color: "green", marginBottom: "15px" }}>
              المحتوى العربي
            </h4>
            <div className="form-grid">
              <div className="form-group">
                <label>العنوان</label>
                <input
                  className="admin-input"
                  required
                  value={form.ar.title}
                  onChange={(e) =>
                    setForm({
                      ...form,
                      ar: { ...form.ar, title: e.target.value },
                    })
                  }
                />
              </div>
              <div className="form-group">
                <label>القسم</label>
                <input
                  className="admin-input"
                  required
                  value={form.ar.category}
                  onChange={(e) =>
                    setForm({
                      ...form,
                      ar: { ...form.ar, category: e.target.value },
                    })
                  }
                />
              </div>
            </div>
            <div className="form-group">
              <label>مقتطف قصير (للعرض الخارجي)</label>
              <textarea
                className="admin-textarea"
                style={{ height: "60px" }}
                required
                value={form.ar.excerpt}
                onChange={(e) =>
                  setForm({
                    ...form,
                    ar: { ...form.ar, excerpt: e.target.value },
                  })
                }
              />
            </div>

            {/* --- محرر النصوص العربي --- */}
            <div className="form-group">
              <label>نص المقال الكامل</label>
              <ReactQuill
                theme="snow"
                modules={modules}
                value={form.ar.content}
                onChange={(content) =>
                  setForm((prev) => ({
                    ...prev,
                    ar: { ...prev.ar, content: content },
                  }))
                }
                style={{ background: "white", direction: "rtl" }}
              />
            </div>
          </div>

          {/* English Section */}
          <div
            style={{
              marginTop: "20px",
              padding: "20px",
              border: "1px solid #ddd",
              borderRadius: "8px",
              background: "#fcfcfc",
            }}
            dir="ltr"
          >
            <h4 style={{ color: "blue", marginBottom: "15px" }}>
              English Content
            </h4>
            <div className="form-grid">
              <div className="form-group">
                <label>Title</label>
                <input
                  className="admin-input"
                  required
                  value={form.en.title}
                  onChange={(e) =>
                    setForm({
                      ...form,
                      en: { ...form.en, title: e.target.value },
                    })
                  }
                />
              </div>
              <div className="form-group">
                <label>Category</label>
                <input
                  className="admin-input"
                  required
                  value={form.en.category}
                  onChange={(e) =>
                    setForm({
                      ...form,
                      en: { ...form.en, category: e.target.value },
                    })
                  }
                />
              </div>
            </div>
            <div className="form-group">
              <label>Short Excerpt</label>
              <textarea
                className="admin-textarea"
                style={{ height: "60px" }}
                required
                value={form.en.excerpt}
                onChange={(e) =>
                  setForm({
                    ...form,
                    en: { ...form.en, excerpt: e.target.value },
                  })
                }
              />
            </div>

            {/* --- English Text Editor --- */}
            <div className="form-group">
              <label>Full Article Content</label>
              <ReactQuill
                theme="snow"
                modules={modules}
                value={form.en.content}
                onChange={(content) =>
                  setForm((prev) => ({
                    ...prev,
                    en: { ...prev.en, content: content },
                  }))
                }
                style={{ background: "white" }}
              />
            </div>
          </div>

          <div style={{ marginTop: "20px", display: "flex", gap: "10px" }}>
            <button className="btn btn-primary">
              {editId ? "حفظ التعديلات" : "نشر المقال"}
            </button>
            {editId && (
              <button
                type="button"
                onClick={() => {
                  setEditId(null);
                  setForm({
                    img: "",
                    date: "",
                    ar: { title: "", category: "", excerpt: "", content: "" },
                    en: { title: "", category: "", excerpt: "", content: "" },
                  });
                }}
                className="btn btn-secondary"
              >
                إلغاء
              </button>
            )}
          </div>
        </form>
      </div>

      {/* القائمة تحت زي ما هي ... */}
      <div className="items-grid">
        {articles.map((art) => (
          <div key={art.id} className="grid-item">
            <img
              src={art.img}
              alt="cover"
              style={{ width: "100%", height: "120px", objectFit: "cover" }}
            />
            <h4>{art.ar.title}</h4>
            <div className="item-actions">
              <button
                onClick={() => handleEdit(art)}
                className="btn btn-secondary btn-action"
              >
                تعديل
              </button>
              <button
                onClick={() => handleDelete(art.id)}
                className="btn btn-danger btn-action"
              >
                حذف
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default LibraryDashboard;
